<template>
	<div class="">
		<el-breadcrumb separator-class="el-icon-arrow-right" class="m-b-20">
			<el-breadcrumb-item class="color_A6A6A6">知识宝典</el-breadcrumb-item>
			<el-breadcrumb-item>选择分类</el-breadcrumb-item>
		</el-breadcrumb>
		<p class="color_666 m-b-20">选择法律分类，开启知识练习之旅。通过考试检验你的法律知识水平！</p>
		<!-- PC端列表式展示 -->
		<div class="category-table-wrap" v-loading="loading">
			<el-table :data="categoryList" style="width: 100%" stripe
				:header-cell-style="{background:'#f5f7fa',color:'#333',fontWeight:'bold'}">
				<el-table-column label="分类名称" min-width="200">
					<template slot-scope="scope">
						<div style="display:flex;align-items:center;">
							<i class="el-icon-notebook-2" style="font-size: 22px; color: #163F88; margin-right: 10px;"></i>
							<span class="font_weight">{{ scope.row.name }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="说明" min-width="180">
					<template slot-scope="scope">
						<span class="color_666">{{ scope.row.remark || '-' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="试卷数" width="100" align="center">
					<template slot-scope="scope">
						<el-tag size="small" type="info">{{ scope.row.paper_count || 0 }} 套</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120" align="center">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="toPapers(scope.row)"
							style="background-color: #163F88; border-color: #163F88;">
							进入练习
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<!-- 移动端列表 -->
		<div class="category-list-mobile" v-loading="loading">
			<div class="category-item-m" v-for="(item, index) in categoryList" :key="index" @click="toPapers(item)">
				<div class="category-item-m-left">
					<i class="el-icon-notebook-2" style="font-size: 22px; color: #163F88; margin-right: 10px;"></i>
					<div>
						<div class="font_weight">{{ item.name }}</div>
						<div class="color_999 font_s12" v-if="item.remark">{{ item.remark }}</div>
					</div>
				</div>
				<div class="category-item-m-right">
					<el-tag size="mini" type="info">{{ item.paper_count || 0 }}套</el-tag>
					<i class="el-icon-arrow-right color_999"></i>
				</div>
			</div>
		</div>
		<div v-if="!loading && categoryList.length === 0" class="text_c p-30">
			<i class="el-icon-folder-opened" style="font-size: 60px; color: #ccc;"></i>
			<p class="color_999 m-t-10">暂无试卷分类</p>
		</div>
	</div>
</template>
<script>
export default {
	name: "PassIndex",
	data() {
		return {
			loading: false,
			categoryList: [],
		};
	},
	activated() {
		this.getCategoryList();
	},
	methods: {
		getCategoryList() {
			this.loading = true;
			this.$api.pass.getCategoryList({}).then((res) => {
				if (res.code == 1) {
					this.categoryList = res.data || [];
				}
			}).catch(() => {}).finally(() => {
				this.loading = false;
			});
		},
		toPapers(item) {
			this.$router.push({
				path: '/pass/papers',
				query: { category_id: item.id, category_name: item.name }
			});
		}
	}
};
</script>
<style scoped>
.category-table-wrap {
	background: #fff;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.category-list-mobile {
	display: none;
}
@media screen and (max-width: 768px) {
	.category-table-wrap {
		display: none;
	}
	.category-list-mobile {
		display: block;
	}
	.category-item-m {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
		margin-bottom: 10px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
	}
	.category-item-m:active {
		background: #f5f7fa;
	}
	.category-item-m-left {
		display: flex;
		align-items: center;
		flex: 1;
		min-width: 0;
	}
	.category-item-m-right {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-shrink: 0;
	}
}
</style>
